import React from 'react';

export default function Footer() {
  return (
    <div className="mt-3 flex flex-col items-center  text-center relative z-10">
      <span className="mx-3 text-sm text-gray-500 sm:text-center">
        Made with 💙 by Muhammad Azar Nuzy © 2022
      </span>
    </div>
  );
}
